import { formatNumberWithCommas } from './formatNumberWithCommas';

export function countDecimals(value: string | number) {
  // Convert the number to a string
  const numberAsString = value.toString();

  // Check if the string contains a decimal point
  if (numberAsString.includes('.')) {
    // Return the length of the substring after the decimal point
    return numberAsString.split('.')[1].length;
  }

  // If no decimal point is found, it's an integer, so return 0
  return 0;
}

/**
 * Formats a number with comma separators and decimal places
 * Example: 111111111.12345 -> "111,111,111.12345"
 */
export function formatNumberWithCommasAndDecimals(
  value: number | string,
  decimals?: number
): string {
  const numberDecimals = countDecimals(value);
  const finalDecimals =
    typeof decimals === 'number' ? decimals : numberDecimals || 5;
  return formatNumberWithCommas(value, finalDecimals);
}
